import { translation as t } from "../../../../inc/helpers";
import Input from "./Input";

export default class InputNumber extends Input {
    constructor({ container, input, label, error }) {
        super({ container, input, label, error });

        this._min = this._container.hasAttribute("data-min")
            ? parseFloat(this._container.getAttribute("data-min"))
            : null;
        this._max = this._container.hasAttribute("data-max")
            ? parseFloat(this._container.getAttribute("data-max"))
            : null;
        this._integer = this._container.hasAttribute("data-integer")
            ? true
            : false;
    }

    _validate(value) {
        if (this._pattern && !this._pattern.test(value))
            return { flag: false, msg: t("ERROR.InvalidFormat") };

        const _value = parseFloat(value);

        if (!this._required && Number.isNaN(_value)) return { flag: null, msg: "" };

        if (this._required && Number.isNaN(_value))
            return { flag: false, msg: t("ERROR.FieldMandatory") };

        if (this._integer && !Number.isInteger(_value))
            return { flag: false, msg: t("ERROR.InvalidFormat") };

        //if (this._pattern && !this._pattern.test(_value))
        //    return { flag: false, msg: t("ERROR.InvalidFormat") };

        if (!this._min && !this._max) return { flag: true, msg: "" };

        if (this._min && _value < this._min)
            return {
                flag: false,
                msg: t("ERROR.Min", [this._min]),
            };

        if (this._max && _value > this._max)
            return {
                flag: false,
                msg: t("ERROR.Max", [this._max]),
            };

        return { flag: true, msg: "" };
    }

    get min() {
        return this._min;
    }
    set min(number) {
        this._min = number;
    }

    get max() {
        return this._max;
    }
    set max(number) {
        this._max = number;
    }
}